import * as React from 'react'

import { cn } from '@/lib/utils'

interface PreviewBoxProps {
  label: string
  children: React.ReactNode
  variant?: 'default' | 'success' | 'warning' | 'error'
  className?: string
}

export function PreviewBox({ label, children, variant = 'default', className }: PreviewBoxProps) {
  const variantStyles = {
    default: 'border-border bg-surface text-foreground',
    success: 'border-success-border bg-success-tint text-success',
    warning: 'border-warning-border bg-warning-tint text-warning',
    error: 'border-danger-border bg-danger-tint text-danger',
  }

  return (
    <div className={cn('rounded-control border p-3', variantStyles[variant], className)}>
      <label className="block text-sm font-medium">{label}</label>
      <div className="mt-1">{children}</div>
    </div>
  )
}
